

export default {
  userShares: state => state.userShares,
};
